// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import Es6Promise from 'es6-promise'
//
//Es6Promise.polyfill()
//import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

import 'babel-polyfill'

Vue.use(MintUI)


/*********************公用工具组件***********************/
import { Lazyload } from 'mint-ui';
Vue.use(Lazyload);
import { Swipe, SwipeItem } from 'mint-ui';
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Loadmore.name, Loadmore);
import { Loadmore } from 'mint-ui';
Vue.use(Loadmore);
//tab切换
import { Navbar, TabItem } from 'mint-ui';

Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
/****************公用的js文件*******************/
//初始化页面的URL变量
import moment from 'moment'
import _commmonWebConfig from './utils/config'
import _commonFun from './utils/util'

Vue.prototype.$moment = moment;
Vue.prototype.commmonWebConfig = _commmonWebConfig
Vue.prototype.commonFun = _commonFun


import _ajaxSubmit from './utils/ajaxSubmit'
Vue.prototype.ajaxSubmit  = _ajaxSubmit


/**************公用组件************************/
// 全局引入脚补
import footer from './components/global/footer';   //默认情况下找的是index文件
Vue.use(footer);   //必须有install

// 全局引入脚补更改
import carExpofooter from './components/global/carExpofooter';   //默认情况下找的是index文件
Vue.use(carExpofooter);   //必须有install
// 全局引入协议
import agreement from './components/global/agreement';   //默认情况下找的是index文件
Vue.use(agreement);   //必须有install

// 全局引入协议
import agreementQuo from './components/global/agreementQuo';   //默认情况下找的是index文件
Vue.use(agreementQuo);   //必须有install

// 全局引入保障
import carExpopromise from './components/global/carExpopromise';   //默认情况下找的是index文件
Vue.use(carExpopromise);   //必须有install

// 全局引入保障
import promise from './components/global/promise';   //默认情况下找的是index文件
Vue.use(promise);   //必须有install
// 全局引入文案修改的保障
import promiseNew from './components/global/promiseNew';   //默认情况下找的是index文件
Vue.use(promiseNew); 
// 全局引入Toast
//import './components/global/toast/toast.css';
//import Toast from './components/global/toast/index';
//Vue.use(Toast);

// import swiper from "swiper"; 
// import "swiper/dist/css/swiper.min.css";

//计算器组件
// 全款
import fullSection from './components/calculator/fullSection';   //默认情况下找的是index文件
Vue.use(fullSection);   //必须有install
// 全款信息
import fullInformation from './components/calculator/fullInformation';   //默认情况下找的是index文件
Vue.use(fullInformation);   //必须有install
// 结算按钮
import settlementBtn from './components/calculator/settlementBtn';   //默认情况下找的是index文件
Vue.use(settlementBtn);   //必须有install
// 品牌车型车款
import markCar from './components/calculator/markCar';   //默认情况下找的是index文件
Vue.use(markCar);   //必须有install
// 首付比例
import markPayment from './components/calculator/markPayment';   //默认情况下找的是index文件
Vue.use(markPayment);   //必须有install
// 还款年限
import markYear from './components/calculator/markYear';   //默认情况下找的是index文件
Vue.use(markYear);   //必须有install
// 交强险
import markInsurance from './components/calculator/markInsurance';   //默认情况下找的是index文件
Vue.use(markInsurance);   //必须有install
// 车船使用税
import markTax from './components/calculator/markTax';   //默认情况下找的是index文件
Vue.use(markTax);   //必须有install
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js